<!-- 检查计划详情页面 -->
<template>
  <div class="check-plan-detail">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="header-left">
        <div class="plan-title">{{ planDetail.planName }}</div>
        <div class="plan-info">
          <span class="plan-id">编号: {{ planDetail.planCode }}</span>
          <el-tag :type="getStatusType(planDetail.status)" class="status-tag">
            {{ getStatusText(planDetail.planStatus) }}
          </el-tag>
        </div>
      </div>
    </div>

    <!-- 操作按钮区域 -->
    <div class="action-bar">
      <div class="action-left">
        <el-button @click="goBack" class="action-btn">
          <i class="el-icon-arrow-left"></i> 返回
        </el-button>
        <!-- <el-button type="primary" @click="handleEdit" class="action-btn">
          <i class="el-icon-edit"></i> 编辑
        </el-button> -->
        <el-button
          type="success"
          @click="handleStartInspection"
          class="action-btn"
        >
          <i class="el-icon-user"></i> 开始检查
        </el-button>
      </div>
      <!-- <div class="action-right">
        <el-dropdown @command="handleMoreActions" class="more-actions">
          <el-button class="action-btn">
            <i class="el-icon-more"></i> 更多操作
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="copy">复制计划</el-dropdown-item>
            <el-dropdown-item command="export">导出报告</el-dropdown-item>
            <el-dropdown-item command="close">关闭计划</el-dropdown-item>
            <el-dropdown-item command="delete">删除计划</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div> -->
    </div>
    <!-- 内容区域 -->
    <div class="content-area">
      <!-- 计划概览卡片 -->
      <div class="overview-card">
        <div class="card-header">
          <span class="card-title">计划概览</span>
        </div>
        <div class="card-content">
          <div class="info-grid">
            <div class="info-item">
              <span class="label">计划编号</span>
              <span class="value">{{ planDetail.planCode }}</span>
            </div>
            <div class="info-item">
              <span class="label">计划名称</span>
              <span class="value">{{ planDetail.planName }}</span>
            </div>
            <div class="info-item">
              <span class="label">检查类型</span>
              <span class="value">{{
                getCheckTypeText(planDetail.checkType)
              }}</span>
            </div>
            <div class="info-item">
              <span class="label">责任部门</span>
              <span class="value">{{ planDetail.responsibleDeptName }}</span>
            </div>
            <div class="info-item">
              <span class="label">负责人</span>
              <span class="value">{{ planDetail.responsiblePersonName }}</span>
            </div>
            <div class="info-item">
              <span class="label">创建人</span>
              <span class="value">{{ planDetail.createName }}</span>
            </div>
            <div class="info-item">
              <span class="label">创建时间</span>
              <span class="value">{{ planDetail.createTime }}</span>
            </div>
            <div class="info-item full-width">
              <span class="label">计划描述</span>
              <span class="value">{{ planDetail.remark }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 时间安排卡片 -->
      <div class="schedule-card">
        <div class="card-header">
          <span class="card-title">时间安排</span>
        </div>
        <div class="card-content">
          <div class="schedule-info">
            <div class="schedule-item">
              <span class="label">计划周期</span>
              <span class="value">{{
                getPlanCycleText(planDetail.planCycle)
              }}</span>
            </div>
            <div class="schedule-item">
              <span class="label">执行频率</span>
              <span class="value">{{
                getCheckFrequencyText(planDetail.checkFrequency)
              }}</span>
            </div>
            <div class="schedule-item">
              <span class="label">频率详情</span>
              <span class="value">{{
                getExecutionDetailText(planDetail.executionDetail)
              }}</span>
            </div>
            <div class="schedule-item">
              <span class="label">执行状态</span>
              <span class="value">{{
                getPlanStatusText(planDetail.planStatus)
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 检查内容卡片 -->
      <div class="content-card">
        <div class="card-header">
          <span class="card-title">检查内容</span>
        </div>
        <div class="card-content">
          <div class="inspection-areas">
            <span class="label">检查区域</span>
            <div class="area-tags">
              <el-tag v-for="area in areaList" :key="area" class="area-tag">
                {{ area }}
              </el-tag>
            </div>
          </div>
          <div class="inspection-form">
            <span class="label">关联检查表</span>
            <span class="value">{{ planDetail.checkListName }}</span>
          </div>
          <div class="inspection-items">
            <span class="label">检查项预览</span>
            <div class="items-list">
              <div
                v-for="item in planDetail.inspectionItems"
                :key="item.id"
                class="item-row"
              >
                <i :class="getItemIcon(item.status)" class="item-icon"></i>
                <span class="item-text">{{ item.name }}</span>
              </div>
            </div>
            <!-- <el-button type="text" class="expand-btn">
              展开<i class="el-icon-arrow-down"></i>
            </el-button> -->
          </div>
        </div>
      </div>

      <!-- 执行历史卡片 -->
      <div class="history-card">
        <div class="card-header">
          <span class="card-title">执行历史</span>
        </div>
        <div class="card-content">
          <div class="history-stats">
            <div class="stat-item">
              <div class="stat-label">应执行</div>
              <div class="stat-value">{{ planDetail.needCount }}</div>
            </div>
            <div class="stat-item">
              <div class="stat-label">已完成</div>
              <div class="stat-value completed">
                {{ planDetail.completeCount }}
              </div>
            </div>
            <div class="stat-item">
              <div class="stat-label">完成率</div>
              <div class="stat-value rate">
                {{ planDetail.completeRate }}%
              </div>
            </div>
          </div>
          <div class="history-table">
            <avue-crud
              ref="historyCrud"
              v-model="historyForm"
              :data="planDetail.recordList"
              :option="historyOption"
              @row-click="handleRowClick"
              @refresh-change="handleRefresh"
            >
              <!-- 自定义记录状态列 -->
              <template slot="status" slot-scope="{ row }">
                <el-tag :type="getExecutionStatusType(row.status)" size="small">
                  {{ row.status }}
                </el-tag>
              </template>
            </avue-crud>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCheckPlanDetail,startCheckPlanUp } from "./api";
import crudMixins from "@/mixins/crud-mixins";
export default {
  name: "CheckPlanDetail",
  mixins: [crudMixins],
  data() {
    return {
      historyForm: {},
      historyOption: {
        border: true,
        stripe: true,
        menu: true,
        addBtn: false,
        delBtn: false,
        editBtn: false,
        viewBtn: true,
        menuWidth: 80,
        menuAlign: "center",
        labelWidth:120,
        column: [
          {
            label: "检查日期",
            prop: "checkDate",
            align: "center",
            overHidden: true,
          },
          {
            label: "检查人员",
            prop: "inspectorNames",
            align: "center",
            overHidden: true,
          },
          {
            label: "受检对象",
            prop: "checkAreaName",
            align: "center",
            overHidden: true,
          },
          {
            label: "发现问题数",
            prop: "problemCount",
            align: "center",
            overHidden: true,
          },
          {
              label: '记录状态',
              prop: 'executionStatus',
              type: 'select',
              remote: true,
              dataType: "number",
              dicUrl: 'api/blade-system/dict-biz/dictionary?code=execution_status',
              props: {
              label: 'dictValue',
              value: 'dictKey'
            },
          },

        ],
      },
      planDetail: {
        planCode: "",
        planName: "",
        status: 1,
        checkType: 1,
        responsibleDeptName: "",
        responsiblePersonName: "",
        createName: "",
        createTime: "",
        remark: "",
        planCycle: 1,
        checkFrequency: 1,
        executionDetail: "",
        planStatus: 0,
        checkListName: "",
        areaName: "",
        inspectionItems: [
          { id: 1, name: "灭火器压力是否正常", status: "completed" },
          { id: 2, name: "消防栓水压是否充足", status: "completed" },
          { id: 3, name: "安全出口标识是否清晰", status: "warning" },
          { id: 4, name: "应急照明设备是否完好", status: "completed" },
        ],
        totalExecutions: 12,
        completedExecutions: 9,
        completionRate: 75,
        executionHistory: [
          {
            inspectionDate: "2023年9月15日",
            inspector: "王强",
            inspectedObject: "A栋生产车间",
            issuesFound: 2,
            status: "已完成",
            operation: "查看",
          },
          {
            inspectionDate: "2023年8月16日",
            inspector: "李明",
            inspectedObject: "B栋仓库",
            issuesFound: 0,
            status: "已完成",
            operation: "查看",
          },
          {
            inspectionDate: "2023年7月14日",
            inspector: "张伟",
            inspectedObject: "办公楼",
            issuesFound: 1,
            status: "已完成",
            operation: "查看",
          },
          {
            inspectionDate: "2023年6月13日",
            inspector: "王强",
            inspectedObject: "食堂",
            issuesFound: 3,
            status: "已完成",
            operation: "查看",
          },
        ],
      },
    };
  },
  computed: {
    // 处理检查区域数据，将字符串转换为数组
    areaList() {
      if (this.planDetail.areaName) {
        // 如果areaName是逗号分隔的字符串，则分割成数组
        return this.planDetail.areaName
          .split(",")
          .map((area) => area.trim())
          .filter((area) => area);
      }
      return [];
    },
  },
  mounted() {
    this.loadPlanDetail();
  },
  methods: {
    // 加载计划详情
    loadPlanDetail() {
      // 从路由参数或API获取计划详情
      const planId = this.$route.params.id;
      console.log("加载计划详情:", planId);
      // 这里可以调用API获取详情数据
      getCheckPlanDetail(planId).then((res) => {
        console.log("计划详情:", res.data.data);
        this.planDetail = res.data.data;
      });
    },

    // 返回列表
    goBack() {
      this.$router.go(-1);
    },

    // 获取状态类型
    getStatusType(status) {
      const statusMap = {
        1: "success", // 启用
        0: "info", // 禁用
      };
      return statusMap[status] || "info";
    },

    // 获取状态文本
    getStatusText(status) {
        console.log(status ,'status123');
        
      const statusMap = {
        1: "启用",
        0: "禁用",
      };
      return statusMap[status] || "未知";
    },

    // 获取检查类型文本
    getCheckTypeText(type) {
      const textMap = {
        1: "消防安全",
        2: "电气安全",
        3: "设备安全",
        4: "化学品安全",
        5: "职业健康",
        6: "环境保护",
        7: "安全管理",
        8: "其他",
      };
      return textMap[type] || type;
    },

    // 获取计划周期文本
    getPlanCycleText(cycle) {
      const textMap = {
        0: "一次性计划",
        1: "周期性计划",
      };
      return textMap[cycle] || cycle;
    },

    // 获取执行频率文本
    getCheckFrequencyText(frequency) {
      const textMap = {
        0: "每日",
        1: "每周",
        2: "每月",
      };
      return textMap[frequency] || frequency;
    },

    // 获取频率详情文本
    getExecutionDetailText(detail) {
      if (!detail) return "-";
       // 根据频率设置详情选项
      const frequencyDetailMap = {
        0: [{ label: "每日", value: "daily" }], // 每日（单选）
        1: [
          // 每周（多选）
          { label: "周一", value: "1" },
          { label: "周二", value: "2" },
          { label: "周三", value: "3" },
          { label: "周四", value: "4" },
          { label: "周五", value: "5" },
          { label: "周六", value: "6" },
          { label: "周日", value: "7" },
        ],
        2: Array.from({ length: 31 }, (_, i) => ({
          label: `${i + 1}日`,
          value: String(i + 1),
        })), // 每月（多选 1-31）
      };
      let arr = []
      let list = frequencyDetailMap[this.planDetail.checkFrequency] || []
      list.forEach(val => {
        if (detail.includes(val.value)) {
          arr.push(val.label)
        }
      })
      return arr.join(',') || detail;
    },

    // 获取执行状态文本
    getPlanStatusText(status) {
      const textMap = {
        0: "未开始",
        1: "进行中",
        2: "已完成",
        3: "已到期",
      };
      return textMap[status] || status;
    },

    // 获取检查项图标
    getItemIcon(status) {
      const iconMap = {
        completed: "el-icon-check",
        warning: "el-icon-warning",
        pending: "el-icon-time",
      };
      return iconMap[status] || "el-icon-time";
    },

    // 获取执行状态类型
    getExecutionStatusType(status) {
      const statusMap = {
        已完成: "success",
        进行中: "primary",
        待执行: "info",
      };
      return statusMap[status] || "info";
    },

    // 编辑计划
    handleEdit() {
      this.$message.info("编辑计划功能");
    },

    // 开始检查
    handleStartInspection() {
      startCheckPlanUp(this.planDetail.id).then(res=>{
        if(res.data.code == 200 ){
          if(res.data.success){
            this.$message.success(`执行成功,开始检查`);
          }else{
            this.$message.error(res.data.data);
          }
        }else{
          this.$message.error(`出现错误`);
        }

      })
    },

    // 更多操作
    handleMoreActions(command) {
      this.$message.info(`执行操作: ${command}`);
    },

    // 查看记录
    handleViewRecord(record) {
      this.$message.info(`查看记录: ${record.inspectionDate}`);
    },

    // 新建执行记录
    handleCreateRecord() {
      this.$message.info("新建执行记录功能");
    },

    // 行点击事件
    handleRowClick(row) {
      console.log("点击行:", row);
    },

    // 刷新事件
    handleRefresh() {
      console.log("刷新数据");
      // 这里可以添加刷新逻辑
    },
  },
};
</script>

<style lang="scss" scoped>
.check-plan-detail {
  padding: 12px;
  background-color: #f5f7fa;
  min-height: 100vh;

  .page-header {
    background: white;
    padding: 20px 24px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin-bottom: 0;

    .header-left {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .plan-title {
        font-size: 24px;
        font-weight: 700;
        color: #303133;
        line-height: 1.2;
      }

      .plan-info {
        display: flex;
        align-items: center;
        gap: 12px;

        .plan-id {
          font-size: 14px;
          color: #909399;
        }

        .status-tag {
          font-size: 12px;
          padding: 4px 8px;
          border-radius: 4px;
        }
      }
    }
  }

  .action-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: white;
    padding: 16px 24px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;

    .action-left {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .action-right {
      display: flex;
      align-items: center;
    }

    .action-btn {
      padding: 8px 16px;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 500;
      display: flex;
      align-items: center;
      gap: 4px;

      i {
        font-size: 14px;
      }
    }

    .more-actions {
      .action-btn {
        background: #f5f7fa;
        border: 1px solid #dcdfe6;
        color: #606266;

        &:hover {
          background: #ecf5ff;
          border-color: #b3d8ff;
          color: #409eff;
        }
      }
    }
  }

  .content-area {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto auto;
    gap: 20px;

    .overview-card {
      grid-column: 1;
      grid-row: 1;
    }

    .schedule-card {
      grid-column: 2;
      grid-row: 1;
    }

    .content-card {
      grid-column: 1 / -1;
      grid-row: 2;
    }

    .history-card {
      grid-column: 1 / -1;
      grid-row: 3;
    }
  }

  .overview-card,
  .schedule-card,
  .content-card,
  .history-card {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;

    .card-header {
      background: #f8f9fa;
      padding: 16px 24px;
      border-bottom: 1px solid #ebeef5;

      .card-title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
      }
    }

    .card-content {
      padding: 24px;
    }
  }

  .info-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;

    .info-item {
      display: flex;
      flex-direction: column;
      gap: 4px;

      &.full-width {
        grid-column: 1 / -1;
      }

      .label {
        font-size: 14px;
        color: #909399;
        font-weight: 500;
      }

      .value {
        font-size: 14px;
        color: #303133;
        font-weight: 500;
      }
    }
  }

  .schedule-info {
    display: flex;
    flex-direction: column;
    gap: 12px;

    .schedule-item {
      display: flex;
      justify-content: space-between;
      align-items: center;

      &.next-inspection {
        .next-date {
          color: #409eff;
          font-weight: 600;
        }
      }

      .label {
        font-size: 14px;
        color: #909399;
        font-weight: 500;
      }

      .value {
        font-size: 14px;
        color: #303133;
        font-weight: 500;
      }
    }
  }

  .inspection-areas {
    margin-bottom: 16px;

    .label {
      display: block;
      font-size: 14px;
      color: #909399;
      font-weight: 500;
      margin-bottom: 8px;
    }

    .area-tags {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;

      .area-tag {
        background: #f5f7fa;
        border: 1px solid #e4e7ed;
        color: #606266;
        font-size: 12px;
        padding: 4px 8px;
        border-radius: 4px;
      }
    }
  }

  .inspection-form {
    margin-bottom: 16px;

    .label {
      display: block;
      font-size: 14px;
      color: #909399;
      font-weight: 500;
      margin-bottom: 4px;
    }

    .value {
      font-size: 14px;
      color: #303133;
      font-weight: 500;
    }
  }

  .inspection-items {
    .label {
      display: block;
      font-size: 14px;
      color: #909399;
      font-weight: 500;
      margin-bottom: 8px;
    }

    .items-list {
      margin-bottom: 8px;

      .item-row {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 4px;

        .item-icon {
          font-size: 16px;

          &.el-icon-check {
            color: #67c23a;
          }

          &.el-icon-warning {
            color: #e6a23c;
          }

          &.el-icon-time {
            color: #909399;
          }
        }

        .item-text {
          font-size: 14px;
          color: #303133;
        }
      }
    }

    .expand-btn {
      color: #409eff;
      font-size: 14px;
      padding: 0;

      &:hover {
        color: #66b1ff;
      }
    }
  }

  .history-stats {
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: #f0f9ff;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
    border: 1px solid #e1f5fe;

    .stat-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
      flex: 1;

      .stat-label {
        font-size: 14px;
        color: #666666;
        font-weight: 500;
      }

      .stat-value {
        font-size: 24px;
        font-weight: 700;
        color: #333333;

        &.completed {
          color: #67c23a;
        }

        &.rate {
          color: #409eff;
        }
      }
    }
  }

  .history-table {
    margin-bottom: 16px;
  }

  .history-actions {
    display: flex;
    justify-content: flex-end;
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .content-area {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto auto;

    .overview-card {
      grid-column: 1;
      grid-row: 1;
    }

    .schedule-card {
      grid-column: 1;
      grid-row: 2;
    }

    .content-card {
      grid-column: 1;
      grid-row: 3;
    }

    .history-card {
      grid-column: 1;
      grid-row: 4;
    }
  }
}
</style>
